import React from "react";
import { sdsuStageImages } from "../../../utils/imageResources";

import SceneObject from "../../SceneObject";



const HepnerHall = React.memo(props => {
    return (
        <SceneObject
            name="HepnerHall"
            transform={{
                position: props.transform.position,
                scale: props.transform.scale,
                rotation: props.transform.rotation,
                opacity: 1
            }}
            $imgUrl={sdsuStageImages.HepnerHallImg}
        />
    );
});

export default HepnerHall;
